import React from 'react';
import { motion } from 'framer-motion';
import '../css/Education.css';

const Education = () => {
  return (
    <section id="education" className="education-section">
      <motion.div
        className="section-heading-wrap"
        initial={{ opacity: 0, y: 35 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
      >
        <span className="section-tag">Academic Background</span>
        <h1>Education</h1>
      </motion.div>

      <motion.div
        className="education-card-modern"
        initial={{ opacity: 0, y: 45, scale: 0.97 }}
        whileInView={{ opacity: 1, y: 0, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.65 }}
      >
        <span className="edu-label">Advanced Diploma</span>
        <h2>Computer Programming and Analysis</h2>
        <h3>George Brown College</h3>
        <p>
          Strong academic foundation in software development, backend systems,
          application design, programming logic, and practical engineering workflows.
        </p>
      </motion.div>
    </section>
  );
};

export default Education;
